import { ModelSnippetFn } from '../types';

export const text: ModelSnippetFn = (props) => `    

import { Model } from "clarifai-nodejs";
import path from "path";

const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}";

const filepath = path.resolve(__dirname, "../../../assets/sample.txt");

const model = new Model({
  url: modelUrl,
  authConfig: {
    pat: "${props.pat}",
  },
});
const modelPrediction = await model.predictByFilepath({
  filepath,
  inputType: "text",
  ${props.deploymentId ? `deployment_id="${props.deploymentId}"` : ''}
});

// Get the output
console.log(
  modelPrediction?.[modelPrediction.length - 1]?.data?.conceptsList,
);
`;

export const image: ModelSnippetFn = (props) => `   
import { Model, Input } from "clarifai-nodejs";

const prompt = "What time of day is it?";
const imageUrl = "https://samples.clarifai.com/metro-north.jpg";
const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}";
const inferenceParams = { temperature: 0.2, maxTokens: 100 };
const multiInputs = Input.getMultimodalInput({
  inputId: "",
  imageUrl,
  rawText: prompt,
});


const model = new Model({
  url: modelUrl,
  authConfig: { pat: "${props.pat}" },
});

const modelPrediction = await model.predict({
  inputs: [multiInputs],
  inferenceParams,
  ${props.deploymentId ? `deployment_id="${props.deploymentId}"` : ''}
});

console.log(modelPrediction?.[0]?.data?.concepts);
`;

export const audio: ModelSnippetFn = (props) => `
import { Model } from "clarifai-nodejs";

const audioUrl =
  "https://s3.amazonaws.com/samples.clarifai.com/GoodMorning.wav";


const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}";


const model = new Model({
  url: modelUrl,
  authConfig: {
    pat: "${props.pat}",
  },
});
const modelPrediction = await model.predictByUrl({
  url: audioUrl,
  inputType: "audio",
  ${props.deploymentId ? `deployment_id="${props.deploymentId}"` : ''}
});

// Print the output
console.log(modelPrediction?.[0]?.data?.text?.raw);
`;

export const video: ModelSnippetFn = (props) => `
import { Model } from "clarifai-nodejs";

const videoUrl = "https://samples.clarifai.com/beer.mp4"
const SAMPLE_MS = 2000;

const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}";

const model = new Model({
  url: modelUrl,
  authConfig: {
    pat: "${props.pat}",
  },
});

const output_config = {"sample_ms": SAMPLE_MS}  # Run inference every 2 seconds

const modelPrediction = await model.predictByUrl({
  url: audioUrl,
  inputType: "video",
   ${props.deploymentId ? `deployment_id="${props.deploymentId}"` : ''}
});

const output = modelPrediction?.[0]?.data;

for (const frame of output.data.frames) {
  console.log("Predicted concepts on frame " + frame.frame_info.time + ":");
  for (const concept of frame.data.concepts) {
    console.log("\t" + concept.name + " " + concept.value);
  }
}

`;
